<template lang="pug">
  //-
  .header-container.fullLayoutHeader(
    :class="{top: $route.name == 'home.index'}"
    :id="hasButtonDownloadStore")
    
    //- noscript
    noscript
      //- GTM
      iframe(
        :src="googleTagManager"
        height="0" width="0"
        style="display:none;visibility:hidden")

    //- ヘッダー
    .hold-header-height
      component(
        :is="fullLayoutHeader")

    div
      //- アニメーション
      transition(
        :name="transitionName"
        mode="out-in")
        router-view.router-view

    base-footer
    //- back-to-top
</template>

<script>
  // import { mapGetters } from 'vuex'
  // import { mapActions } from 'vuex'
  import BaseFooter from './partials/Footer.vue'
  import BackToTop from './partials/BackToTop.vue'
  import HeaderPc from './partials/header/IndexPc.vue'
  import HeaderSp from './partials/header/IndexSp.vue'

  export default {
    name: 'base-layout',

    components: {
      BaseFooter, // base-footer
      HeaderPc,
      HeaderSp,
      BackToTop, // back-to-top
    },
    data() {
      return {
      }
    },
    computed: {
      // vuexから関数「 layout 」を「 layoutHeader 」としてを呼び出している。いや違うlayoutの中のlayoutheader
      // /src/store/modules/layout
      // ...mapGetters('layout', ['layoutHeader']),
      // エフェクトの名前「 slide-left 」を返す。値の場所は routes/index.js
      transitionName() {
        return this.$route.meta.transitionName
      },
      // 使うヘッダーコンポーネント名、例えば「 HeaderUserPc 」をかえす
      fullLayoutHeader() {
        // モバイルであれば「 Sp 」、PCなら「 Pc 」を返す
        const endPrefix = (this.isMobile) ? 'Sp' : 'Pc'
        // ページごとの名前「 User 」を返す。upperFirstは頭文字を大文字にする。
        // const layoutHeader = _.upperFirst(this.layoutHeader)
        // 連結する
        return `Header${endPrefix}`
      },
      // ヘッダーに AppStoreボタン を表示する
      hasButtonDownloadStore() {
        // <App> > data > $route > name が index.index か user.index なら true
        const condition = (this.$route.name) === 'index.index'
        // もしTOPページなら idをつけて、Appストア のダウンロードボタンを表示する
        if (condition) {
          return 'fix-store'
        }
        return false
      },
      // GTMのIDは、.envの VUE_APP_GMT_ID に書いてあります。
      googleTagManager() {
        return `https://www.googletagmanager.com/ns.html?id=${process.env.VUE_APP_GMT_ID}`
      }
    }
  }
</script>

<style>
  /* ページ切り替えアニメーションの速度 */
  .router-view {
    width: 100%;
    transition: all .5s cubic-bezier(.55, 0, .1, 1);
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(30px, 0);
    transform: translate(30px, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-30px, 0);
    transform: translate(-30px, 0);
  }
  .test{
    width: 100%;
    height: 100%;
    background-color: #f00;
    /* background-image: url('../assets/images/bg.png') */
  }
</style>
